import { noneProvider } from './none';
import { omnihitAuthRefreshFetch, omnihitProvider } from './omnihit';
import { type IProvider, PROVIDERS, type ProviderId } from './provider-types';
import { salesforceProvider } from './salesforce';

export const providerMap: Record<ProviderId, IProvider> = {
  [PROVIDERS.SALESFORCE]: salesforceProvider,
  [PROVIDERS.OMNIHIT]: omnihitProvider,
  [PROVIDERS.NONE]: noneProvider,
};

export const getProviderById = (id: ProviderId): IProvider => {
  return providerMap[id];
};

export * from './provider-types';
export { omnihitAuthRefreshFetch };
